import React from "react";
import works from "../Assets/FAQ/Questions-pana.svg";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";

const Content10 = () => {
  const navigate = useNavigate();

  const faqs = [
    {
      ques: "Download and Sign Up",
      ans: "Get started by downloading MotoDoctor(Rider) from the App Store or Google Play. Sign up and create your profile for a personalized experience.",
    },
    {
      ques: "Request Assistance",
      ans: "When you're facing a breakdown or need a quick check-up, simply open the app, and request assistance. Provide details about your location and the issue you're experiencing.",
    },
    {
      ques: "Get Matched with a Mechanic:",
      ans: "Our smart matching algorithm will connect you with the nearest available mechanic who specializes in your bike's make and model.",
    },
    {
      ques: "Track and Communicate:",
      ans: " Track the mechanic's arrival in real-time and communicate directly through the app. Receive updates on the progress of your service.",
    },
    {
      ques: "Pay Securely:",
      ans: "Once the service is complete, pay securely through the app. No need for cash transactions – it's all hassle-free.",
    },
  ];

  const howToSchema = {
    "@context": "https://schema.org",
    "@type": "HowTo",
    name: "How to Use MotoDoctor Rider App",
    description: "Step-by-step guide to using the MotoDoctor Rider app for roadside assistance and repairs.",
    step: faqs.map((item) => ({
      "@type": "HowToStep",
      name: item.ques.replace(":", ""),
      text: item.ans,
    })),
  };
  return (
    <>
      <Helmet>
        <title>How It Works - MotoDoctor Rider App</title>
        <meta
          name="description"
          content="Learn how MotoDoctor works – from signing up to requesting assistance, tracking mechanics, and making secure payments. A simple 5-step guide for all users."
        />
        <meta
          name="keywords"
          content="How it works MotoDoctor, rider app guide, MotoDoctor steps, bike repair booking, roadside help steps"
        />
        <link rel="canonical" href="/mannual" />

        {/* ✅ Structured Data */}
        <script type="application/ld+json">{JSON.stringify(howToSchema)}</script>
      </Helmet>
      <section id="Services">
        <div
          style={{
            minHeight: "100vh",
            width: "100vw",
            backgroundColor: "#fff",
            padding: "5vh 0",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: 30,
            }}
          >
            <div
              style={{
                fontWeight: 600,
                textAlign: "center",
                textAlignLast: "center",
              }}
              className="content10Head"
            >
              How It Works ?
            </div>
            {/* <div
          style={{
            fontSize: 16,
            color: "#666",
            width: "50%",
            textAlignLast: "center",
          }}
        >
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis,
          pulvinar dapibus leo.
        </div> */}
            <hr
              style={{
                width: "5%",
                border: "1.5px solid #FF8264",
              }}
            />
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              paddingTop: 50,
            }}
            className="content10"
          >
            <img
              src={works}
              style={{ height: "100%", objectFit: "cover" }}
              className="content10Img"
              alt="motodoctor image"
            />
            <div className="content10Faqs">
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 20,
                    paddingBottom: 20,
                  }}
                >
                  <div
                    style={{
                      fontSize: 20,
                      fontWeight: 600,
                      padding: "15px 10px",
                      backgroundColor: "#FFF2EF",
                      borderRadius: 10,
                    }}
                  >
                    {faq.ques}
                  </div>
                  <div style={{ padding: "0px 10px" }}>{faq.ans}</div>
                </div>
              ))}
            </div>
          </div>
          {/* ✅ CTA Button to /rider */}
          <div style={{ textAlign: "center", marginTop: "40px" }}>
            <button
              onClick={() => navigate("/rider")}
              style={{
                backgroundColor: "#FF8264",
                color: "#fff",
                padding: "12px 24px",
                borderRadius: "8px",
                fontWeight: "bold",
                fontSize: "16px",
                border: "none",
                cursor: "pointer",
                transition: "background-color 0.3s",
              }}
              onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#ff5127")}
              onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#FF8264")}
            >
              Book Your Bike Service Today
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default Content10;
